import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  ConfigurationProgressStatus,
  GuidDictionaryItem,
  MeterStatus,
} from '../../../../../../../api/api-reference';
import { MultiSelectDropdownSearchComponent } from '../../../../multi-select-dropdown-search/multi-select-dropdown-search.component';
import { FilterPanelComponent } from '../../filter-panel.component';

export interface AcquisitionFilterOutput {
  selectedMeterOnlineStatus: MeterStatus | undefined;
}

@Component({
  selector: 'app-acquisition-monitor-filter',
  standalone: true,
  imports: [CommonModule, NgFor, TranslateModule, FilterPanelComponent, MultiSelectDropdownSearchComponent],
  templateUrl: './acquisition-monitor-filter.component.html',
  styleUrl: './acquisition-monitor-filter.component.scss',
})
export class AcquisitionMonitorFilterComponent implements OnInit {
  @Input() onlineStatus: MeterStatus | undefined = undefined;
  @Output() applied = new EventEmitter<AcquisitionFilterOutput>();
  readonly meterStatuses = Object.values(MeterStatus);
  draftMeterStatus: MeterStatus | undefined = undefined;

  get activeFilterCount(): number {
    return (
      this.onlineStatus != null ? 1 : 0
    );
  }

  constructor(private client: Client, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.reset();
  }

  isIn<T>(list: T[], item: T): boolean {
    return list.includes(item);
  }

  toggle<T>(list: T[], item: T): T[] {
    return list.includes(item) ? list.filter((i) => i !== item) : [...list, item];
  }

  toggleGuid(list: string[], item: GuidDictionaryItem): string[] {
    const val = item.value!;
    return list.includes(val) ? list.filter((v) => v !== val) : [...list, val];
  }

  onMeterStatusChange(status: string): void {
    const statusEnum = MeterStatus[status as keyof typeof MeterStatus];
    this.draftMeterStatus = this.draftMeterStatus === statusEnum ? undefined : statusEnum;
  }

  onApply(): void {
    this.applied.emit( {selectedMeterOnlineStatus: this.draftMeterStatus});
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftMeterStatus = this.onlineStatus;
  }
}
